module.exports = __webpack_public_path__ + "static/img/y48.a667e93.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/y48.jpg
// module id = Z5R+
// module chunks = 1